/* eslint-disable no-restricted-globals */
// This code executes in its own worker or thread
import { decompress } from 'compress-json';
import { decompressSync, strFromU8 } from 'fflate';
// must define for service worker
self.__WB_MANIFEST;
export const fetchJSONFromGZFile = async (endpoint) => {
    const buffer = await fetch(`${endpoint}/json/car.json.gz?hash=${Math.random()}`).then(res => res.arrayBuffer());
    const compressed = new Uint8Array(buffer);
    const decompressed = decompressSync(compressed);
    return strFromU8(decompressed);
};
const loadJson = async (endpoint) => {
    const response = await fetchJSONFromGZFile(endpoint);
    if (response) {
        const result = JSON.parse(response);
        const cars = decompress(result);
        let countCalc = 0;
        cars.forEach(car => {
            countCalc += car.op_leas_calcs ? car.op_leas_calcs.length : 0;
        });
        return {
            countCalc,
            result: cars,
        };
    }
    return {
        countCalc: 0,
        result: [],
    };
};
onmessage = (message) => {
    if (message.data.action === 'loadData') {
        loadJson(message.data.endpoint).then(result => {
            postMessage(result);
        });
    }
};
